import EventCompanyDetails from "@features/events/pages/settings/components/CompanyDetails";
import EventSettingsMembersAndPermissions from "@features/events/pages/settings/components/MembersAndPermissions";
import EventEditMember from "@features/events/pages/settings/components/EditMemberWrapper";
import EventEditInvitee from "@features/events/pages/settings/components/EditInviteWrapper";
import EventSettingsPayouts from "@features/events/pages/settings/components/SettingsPayouts/SettingsPayouts";
import { ProtectedRoute } from "@shared/ui";
import { EVENT_ROUTES, ROOTS, SETTINGS_ROUTES } from "@app/config/constants";
import { Outlet, Route } from "react-router-dom";

export default function getEventSettingsRoutes() {
  return (
    <Route
      path={`${ROOTS.EVENTS}/:eventOrganizerId/${EVENT_ROUTES.SETTINGS}`}
      element={
        <ProtectedRoute>
          <Outlet />
        </ProtectedRoute>
      }
    >
      <Route path={SETTINGS_ROUTES.DETAILS} element={<EventCompanyDetails />} />
      <Route
        path={`${SETTINGS_ROUTES.MEMBERS_PERMISSIONS}/members/:memberId`}
        element={<EventEditMember />}
      />
      <Route
        path={`${SETTINGS_ROUTES.MEMBERS_PERMISSIONS}/invites/:inviteId`}
        element={<EventEditInvitee />}
      />
      <Route
        path={SETTINGS_ROUTES.MEMBERS_PERMISSIONS}
        element={<EventSettingsMembersAndPermissions />}
      />
      <Route path={SETTINGS_ROUTES.PAYOUTS} element={<EventSettingsPayouts />} />
    </Route>
  );
}
